<div class="cmn-inner-page-wrapper">
<div class="head-row">
  <div class="head">
    <h1>Plans and Subscriptions</h1>
  </div>

  <div
    class="drag-hint"
    *ngIf="(draggable$ | async) && features.length > 1"
  >
    You can reorder features by dragging the ⠿ icon
  </div>
</div>


  <div class="content-flex-wrapper" *ngIf="!contentLoading">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="table-flex-wrapper">
        <div class="table-wrapper">
          <div class="overflow-wrapper" cdkDropList (cdkDropListDropped)="drop($event)">

            <table class="feature-table">
              <thead>
                <tr>
                  <th class="plans">Features</th>
                  <th *ngFor="let plan of plans" class="plans">
                    {{ plan.planName }}
                  </th>

                  <th class="actions-th" *ngIf="features.length !== 0">
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let feature of features; let i = index" cdkDrag [cdkDragDisabled]="!(draggable$ | async)"
                  class="draggable-row">
                  <td cdkDragHandle class="drag-handle" [class.enabled-handle]="draggable$ | async"
                    matTooltip="Drag to reorder features" matTooltipPosition="right">
                    <span class="icon">⠿</span>
                    {{ feature.featureName }}
                  </td>


                  <td *ngFor="let plan of plans">
                    <input type="checkbox" [checked]="isChecked(plan.id, feature.id)"
                      (change)="onToggleCheckbox(plan.id, feature.id, $event)" />
                  </td>
                  <td>
                    <div class="edit-delete-flex-wrapper">
                      <img (click)="openDialog('edit-feature', feature)"
                        src="../../../assets/images/icons/icon-edit.svg" alt="Edit"
                        *appHasPermission="'UPDATE_FEATURE'" />
                      <img (click)="onDelete(feature.id)" src="../../../assets/images/icons/icon-delete.svg"
                        alt="Delete" *appHasPermission="'DELETE_FEATURE'" />
                    </div>
                  </td>
                </tr>
                <tr *ngIf="!features?.length" class="no-features-found">
                  <td [attr.colspan]="plans.length + 2">No features found</td>
                </tr>
                <tr class="add-feature-btn" *appHasPermission="'ADD_FEATURE'" (click)="openDialog('add-feature')">
                  <td [attr.colspan]="plans.length + 2">
                    <div class="add-feature-btn-flex-wrapper">
                      <span>Add a new feature</span>
                      <div class="add-feature-icon-flex-wrapper">
                        <img src="../../../assets/images/icons/primary-add-icon.svg" alt="" />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="button-flex-wrapper" *appHasPermission="'UPDATE_FEATURE'">
          <button type="button" (click)="onCancel()" class="cmn-cancel-btn">
            Cancel
          </button>
          <button type="submit" class="cmn-next" (click)="onSubmit()" [disabled]="isSubmitting">
            {{ isSubmitting ? 'Saving...' : 'Save Changes' }}
          </button>
        </div>
      </div>
    </form>
  </div>
  <app-content-loader [visible]="contentLoading"></app-content-loader>
</div>
